<template>
  <div v-if="item" class="mt-2 notification-action-item">
    <copy-participant-ssn v-show="showCopySsnBtn" :item="item"></copy-participant-ssn>
    <div v-for="v in items" v-bind:key="v" class="col-12">
      <label class="bold">{{v[0]}}</label>
      <div v-bind:class="{ 'pull-right': v[1].length < 15 }">{{v[1]}}</div>
    </div>
    <div v-if="this.items == null">
      <label class="bold">{{this.item.message}}</label>
    </div>
  </div>
</template>

<script>
import CopyParticipantSsn from './CopyParticipantSsn.vue';

export default {
  props: ["item"],
  data()
  {
    return {
      items: null,
    }
  },
  computed: {
    showCopySsnBtn(){
      return ["account-terminated", "participant-terminated", "participant-terminated-review-cobra"].includes(this.item.itemType);
    }
  },
  watch:{
    item()
    {
      if(this.item)
      {
        this.load();
      }
    }
  },
  methods: {
    load()
    {
      this.items = this.item.message.split(/,|;/);

        for (var i = 0; i < this.items.length; i++) {

          this.items[i] = this.items[i].split(/:(.+)/);
      }

      let problems = 0;

      for (var i = 0; i < this.items.length; i++) {
        var item = this.items[i];

        if (item[1]){
          if(!item[1].includes("=>")) {
            problems ++;
          }
        }else {
          problems ++;
        }   
      }

      if(problems > 0) {
          this.items = null;
        }
    }
  },
  mounted()
  {
    this.load();
  }
};
</script>

<style lang="scss" scoped>
.notification-action-item {
  .bold {
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/action-items/types/NotificationActionItem.vue